import { render } from "./SimpleSidebar.vue?vue&type=template&id=2d02214e&scoped=true"
import script from "./SimpleSidebar.vue?vue&type=script&lang=js"
export * from "./SimpleSidebar.vue?vue&type=script&lang=js"

import "./SimpleSidebar.vue?vue&type=style&index=0&id=2d02214e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d02214e"]])

export default __exports__